import { render } from "./AppointmentDashboard.vue?vue&type=template&id=d0461940&scoped=true"
import script from "./AppointmentDashboard.vue?vue&type=script&lang=js"
export * from "./AppointmentDashboard.vue?vue&type=script&lang=js"

import "./AppointmentDashboard.vue?vue&type=style&index=0&id=d0461940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0461940"]])

export default __exports__